// #5628: één gecontroleerde harde reload haalt verse assets binnen na een deploy. De
// loopguard (10s-venster via sessionStorage) voorkomt een reload-storm wanneer een asset
// écht kapot of onbereikbaar is i.p.v. enkel verouderd.
export const NAV_RELOAD_GUARD_KEY = 'nn-vite-preload-reloaded-at'
const RELOAD_GUARD_MS = 10_000

// Tussen preventDefault() en het wegvallen van de pagina crasht Inertia nog op de lege
// module; Sentry moet die fouten negeren, de reload lost ze op (LARAVEL-VUE-KY).
let reloadingForStaleChunk = false

export function isReloadingForStaleChunk(): boolean {
    return reloadingForStaleChunk
}

export function resetVitePreloadErrorState(): void {
    reloadingForStaleChunk = false
}

export interface VitePreloadErrorDeps {
    storage: Pick<Storage, 'getItem' | 'setItem'>
    reload: () => void
    report: (payload: unknown) => void
    now?: () => number
}

export function handleVitePreloadError(event: Event, deps: VitePreloadErrorDeps): void {
    const now = (deps.now ?? Date.now)()
    const last = Number(deps.storage.getItem(NAV_RELOAD_GUARD_KEY) ?? 0)

    // De reload hielp niet: fout niet onderdrukken. Met preventDefault() levert de import
    // undefined op en crasht Inertia stil op module.default (LARAVEL-VUE-KY). Enkel dit
    // geval rapporteren; een verouderde chunk na een deploy lost de reload zelf op.
    if (now - last < RELOAD_GUARD_MS) {
        deps.report((event as Event & { payload?: unknown }).payload)
        return
    }

    event.preventDefault()
    reloadingForStaleChunk = true
    deps.storage.setItem(NAV_RELOAD_GUARD_KEY, String(now))
    deps.reload()
}
